import { BRAND_NAME } from '../lib/brand.js';

/**
 * The website's wordmark - Craig's ruling B, 29 September 2026.
 *
 * "Entity" in `ink` and "Links" in `blue`, text only and no mark, exactly as
 * entitylinks.com's nav draws it, so the first screen a buyer sees after
 * pressing "Open an account" is recognisably the same product.
 *
 * **It only ever sits on the dark ground.** Both colours are the website's dark
 * tokens and `blue` is 2.2:1 on white, so it has no light variant on purpose.
 *
 * The two halves are sliced from `BRAND_NAME` rather than typed, so a rename is
 * still a one-file change, and the label gives a screen reader one word rather
 * than two.
 */
const SPLIT = BRAND_NAME.indexOf('Links');

export function Wordmark(): React.JSX.Element {
  return (
    <span
      role="img"
      aria-label={BRAND_NAME}
      data-testid="wordmark"
      className="font-sans text-[22px] leading-none font-bold tracking-[-0.022em] whitespace-nowrap text-ink"
    >
      {BRAND_NAME.slice(0, SPLIT)}
      <span className="text-blue">{BRAND_NAME.slice(SPLIT)}</span>
    </span>
  );
}
